import CreateLive from './src/main.vue';

/* istanbul ignore next */
CreateLive.install = function(Vue) {
  Vue.component(CreateLive.name, CreateLive);
};

export default CreateLive;
